import { render } from "./TypeDialog.vue?vue&type=template&id=48f13eda&scoped=true"
import script from "./TypeDialog.vue?vue&type=script&lang=js"
export * from "./TypeDialog.vue?vue&type=script&lang=js"

import "./TypeDialog.vue?vue&type=style&index=0&id=48f13eda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f13eda"]])

export default __exports__